import React from 'react'
import styles from './staffCard.module.css'

import { Image } from '../../atoms/image'
import { Title } from '../../atoms/title'
import { SubTitle } from '../../atoms/subtitle'
import { Button } from '../../atoms/button'
import { Label } from '../../atoms/label'

import staffIcon from '../../assets/images/staffProfile.svg'

export const StaffCard = props => {
    return <div className={[styles.container, styles.flex].join(' ')}>
        <Image src={props.profilePic ? props.profilePic : staffIcon} width="70px" rounded />
        <div className={styles.staffInfo}>
            <Title>{props.name}</Title>
            <SubTitle>{props.role}</SubTitle>
            <Label>{props.email}</Label>
            <Label>{props.onliveId}</Label>
        </div>
        <div className={[styles.flex, styles.editButton].join(' ')}>
            <Button primary onClick={props.onEditClick} >Edit</Button>
        </div>
    </div>
}